"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 32", width: "1em", height: "1em", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 16c0 6.075 4.925 11 11 11 6.076 0 11-4.925 11-11 0-6.076-4.924-11-11-11C4.925 5 0 9.924 0 16zm5.493 4.963c.261-1.496 1.867-2.293 3.342-2.421.599-.053 1.046-.391 1.197-.906.15-.515-.03-1.093-.435-1.405-1.126-.868-1.301-1.808-1.391-2.776-.068-.722.107-2.098.867-2.932.46-.506 1.064-.751 1.846-.751h.161c.783 0 1.387.245 1.847.751.76.834.935 2.21.866 2.932-.09.968-.264 1.908-1.389 2.775-.407.314-.585.892-.435 1.407.151.514.598.852 1.196.905 1.475.128 3.08.925 3.343 2.421.198 1.139.485 2.396.609 2.93C15.424 25.208 13.305 26 11 26s-4.424-.792-6.117-2.107c.124-.534.41-1.791.61-2.93zm12-.172c-.306-1.748-2.011-3.052-4.241-3.245-.274-.025-.311-.149-.323-.19-.036-.125.015-.279.085-.334 1.442-1.111 1.673-2.376 1.775-3.473.073-.774-.069-2.542-1.123-3.7-.651-.715-1.52-1.077-2.586-1.077h-.161c-1.065 0-1.934.362-2.586 1.077-1.053 1.158-1.195 2.926-1.123 3.7.103 1.097.333 2.362 1.777 3.474.07.054.121.208.085.333-.012.041-.049.165-.324.19-2.231.193-3.935 1.497-4.24 3.245a52.733 52.733 0 01-.482 2.361A9.96 9.96 0 011 16C1 10.486 5.486 6 11 6s10 4.486 10 10a9.968 9.968 0 01-3.026 7.153 51.812 51.812 0 01-.481-2.362z" })));
};
var SvgProfile = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgProfile;
var templateObject_1;
